import validator from "validator";
import message from "../../../../messages/advertise/banner";

const validateAddress = (address) => {
  if (validator.isEmpty(address)) {
    return message.ADDRESS_DOSE_NOT_EXIST;
  }

  if (!address.trim().length) {
    return message.ADDRESS_DOSE_NOT_EXIST;
  }

  return true;
};

const validateActive = (active) => {
  if (validator.isEmpty(active)) {
    return message.ACTIVE_NOT_EXIST;
  }

  if (!(active == 1 || active == 0)) {
    return message.ACTIVE_INVALID;
  }

  return true;
};

const validateFormEditAdvertiseBanner = (info) => {
  const resValidateAddress = validateAddress(info.address);
  if (resValidateAddress != true) {
    return resValidateAddress;
  }

  const resValidateActive = validateActive(info.active);
  if (resValidateActive != true) {
    return resValidateActive;
  }

  return true;
};

export default validateFormEditAdvertiseBanner;
